import './currencies-filter.less';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import SwitchControlSingleDecorator from '../shared/switch-control/single/main';

import { getCurrencyIcon } from '../../../../shared/js/get-currency-icon';

const Currencies = ({
	listOfCurrencies,
	currentCurrency,
	selectCurrency
}) => (
	<SwitchControlSingleDecorator
		className="stat-currencies-list"
		transformToDropdown={true}
		activateBreakpoint={1468}>
		{ listOfCurrencies.map((entity, i) => {
			const title = !entity.id ? entity.text : getCurrencyIcon(entity.id);
			return (
				<button
					key={i}
					value={title}
					className={cn({
						'ui-btn ui-btn-secondary': true,
						active: entity.id === currentCurrency
					})}
					onClick={() => selectCurrency(entity.id)}
				>
					{title}
				</button>
			);
		}) }
	</SwitchControlSingleDecorator>
);

Currencies.propTypes = {
	listOfCurrencies: PropTypes.array,
	currentCurrency: PropTypes.string,
	selectCurrency: PropTypes.func
};

export default Currencies;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/currencies-filter.js